import { License } from '../../domain/license';
import { ProductArray } from '../../domain/product';
import { NoteArray } from '../../domain/note';
import { PoolStudioSettingsGroupArray } from '../../domain/poolstudio.settings.group';
import { PinItem } from '../../domain/pin';

export interface ILicenseFullResponse {
    License: License;
    AvailableProducts: ProductArray;
    Notes: NoteArray;
    AvailablePoolStudioSettingsGroups: PoolStudioSettingsGroupArray;
    Pin: PinItem;
}

export class LicenseFullResponse implements ILicenseFullResponse {
    License: License;
    AvailableProducts: ProductArray;
    Notes: NoteArray;
    AvailablePoolStudioSettingsGroups: PoolStudioSettingsGroupArray;
    Pin: PinItem;

    public static FixDates(item: LicenseFullResponse) {

        License.FixDates(item.License);

    }
}
